import { render, staticRenderFns } from "./ModalForgotAdress.vue?vue&type=template&id=79b87c5e&scoped=true&"
import script from "./ModalForgotAdress.vue?vue&type=script&lang=js&"
export * from "./ModalForgotAdress.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgotAdress.vue?vue&type=style&index=0&id=79b87c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b87c5e",
  null
  
)

export default component.exports